
import { NonIdealState } from '@blueprintjs/core';
import autobind from 'autobind-decorator';
import * as React from 'react';

import Loading from 'common/fragments/Loading';
import { TimelineView } from 'common/views/timeline/Timeline.view';
import { Query } from 'core/api/typedQuery';
import { IPanelProps, Panel } from 'core/decorators/Panel';
import { isEmpty } from 'core/util/ArrayUtils';
import labelProvider from './ConditionProgress.labels';
import ConditionProgressConfig from './ConditionProgressConfig';
import RemoteCondition from './entities/RemoteCondition';

/**
 * @overview:
 */

const { Labels } = labelProvider;
const RemoteConditionsQuery = Query.queryMany<RemoteCondition, any>(RemoteCondition);

@Panel({ id: "condition-progress", configClass: ConditionProgressConfig, labelProvider })
export class ConditionProgressPanel extends React.PureComponent<IPanelProps<ConditionProgressConfig>> {

	@autobind
	private getNodes(conditions: RemoteCondition[]) {

		return conditions.map((c) => ({
			label: c.description,
			active: c.value
		}));
	}

	public render() {
		const { config } = this.props;

		if(!config.conditionIds) {
			return "Select conditions";
		}

		return (
			<RemoteConditionsQuery params={{ids: config.conditionIds}}>
				{
					({ data, loading }) => {

						if (loading) {
							return <Loading/>;
						}

						if (isEmpty(data)) {
							return (
								<NonIdealState title={<Labels.NoConditions />} />
							);
						}

						return (
							<TimelineView viewKey="conditionsProgress" nodes={this.getNodes(data)} />
						);
					}
				}
			</RemoteConditionsQuery>
		);
	}
}







// WEBPACK FOOTER //
// ./src/panels/conditionProgress/ConditionProgress.panel.tsx